import { HttpClient } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { GkComponentsModule, GkMapModule } from "@gk/gk-modules";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { SharedModule } from "../../shared/shared.module";
import { createTranslateLoader } from "../address-number-request-portal/address-number-request-portal.module";
import { LandAndBuildingRegisterDataUpdateRequestRoutingModule } from "./land-and-building-register-data-update-request-routing.module";
import { LandAndBuildingRegisterDataUpdateRequestComponent } from "./land-and-building-register-data-update-request.component";
import { LBRDURNewDataUpdateRequestComponent } from "./new-data-update-request/new-data-update-request.component";
import { LBRDURNewDataUpdateRequestFormService } from "./services/new-data-update-request-form/new-data-update-request-form.service";

@NgModule({
  declarations: [
    LandAndBuildingRegisterDataUpdateRequestComponent,
    LBRDURNewDataUpdateRequestComponent,
  ],
  imports: [
    SharedModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    GkMapModule,
    GkComponentsModule,
    LandAndBuildingRegisterDataUpdateRequestRoutingModule,
  ],
  providers: [LBRDURNewDataUpdateRequestFormService],
})
export class LandAndBuildingRegisterDataUpdateRequestModule {}
